<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Caregivers:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Caregiver'}"
                                                add-edit-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Caregiver"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Children:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Child'}"
                                                add-edit-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Child"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Others:</h4>
                <div>
                    <FamilyClientDisplayAndEdit :edit-mode="EditMode"
                                                :global-update="false"
                                                get-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/GetContacts"
                                                :get-payload="{Id: RecordData.Id, ClientType: 'Other'}"
                                                add-edit-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/AddEditContact"
                                                :add-edit-payload="{ChartID: RecordData.Id}"
                                                delete-endpoint="StrongFamilies/CommunityFamilies/FamilyMembers/DeleteContact"
                                                :require-dob="false"
                                                contact-category="Other"
                                                :relationship-options="FamilyRelationOptions"
                                                relationship-label="Family"
                                                :display-age="true"
                                                :display-relationship="true" />
                </div>
            </div>
        </div>

        <!--<div class="row record-section-row">
        <div class="col">
            <h4>Pets:</h4>
            <div>
                <FamilyDogDisplayAndEdit :edit-mode="EditMode"
                                         :global-update="false"
                                         get-endpoint="Foster/ResourceFamily/Contacts/Dogs/GetDogs"
                                         :get-payload="{Id: FamilyRecordData.Family.Id}"
                                         add-edit-endpoint="Foster/ResourceFamily/Contacts/Dogs/AddEditDog"
                                         :add-edit-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id}"
                                         delete-endpoint="Foster/ResourceFamily/Contacts/Dogs/DeleteDog"
                                         :family-record-data="FamilyRecordData" />
            </div>
        </div>
    </div>-->


        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    //import SingleMembershipEditor from '../../../../Core/ItemEditors/SingleMembershipEditor';
    //import MultiMembershipEditor from '../../../../Core/ItemEditors/MultiMembershipEditor';
    //import CareCommunityEditor from '../../../../Core/ItemEditors/CareCommunityEditor';
    import FamilyClientDisplayAndEdit from '../../../../Core/ItemEditors/FamilyClientDisplayAndEdit.vue';
    //import FamilyDogDisplayAndEdit from './FamilyDogDisplayAndEdit.vue';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            //SingleMembershipEditor,
            //MultiMembershipEditor,
            FamilyClientDisplayAndEdit,
            //FamilyDogDisplayAndEdit,
            //CareCommunityEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            }
        }
    }
</script>

<style scoped>
</style>